import { css } from '@emotion/react';

import image from 'src/assets/jpg/succes-failure-hero.jpg';
import { SECONDARY_FONT_FAMILY_HOS } from 'src/styles/constants';
import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',

        ...(isHosTheme && {
            minHeight: '734px',
            justifyContent: 'center',
            alignItems: 'center',
        }),
    }),

    title: css({
        ...(isHosTheme && {
            fontFamily: SECONDARY_FONT_FAMILY_HOS,
            fontSize: '26px',
            lineHeight: '30px',
            fontWeight: 700,
            marginBottom: '10px',

            [theme.breakpoints.up('lg')]: {
                fontSize: '26px',
            },
        }),
    }),

    imageContainer: css({
        height: '190px',
        flexShrink: '0',
        background: `url(${image}) lightgray no-repeat center/cover`,
        backgroundPosition: '45% 32%',
        backgroundSize: '150%',
        marginBottom: '50px',

        [theme.breakpoints.up('lg')]: {
            backgroundSize: '100%',
        },

        ...(isHosTheme && {
            display: 'none',
        }),
    }),

    wrapper: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
        textAlign: 'center',
        padding: '30px 20px',
        gap: '30px',
        [theme.breakpoints.up('md')]: {
            width: '494px',
            gap: '40px',
        },
        marginBottom: isHosTheme ? '0px' : '83px',
    }),
};
